import { useContext, Context } from "react"
import { ThemeContext } from "styled-components"

import { ThemeProps } from "src/legacy/theme"

const useTheme = (): ThemeProps => {
  return useContext(ThemeContext as unknown as Context<ThemeProps>)
}

export default useTheme
